var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.59 33.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#36b22d;}.cls-2{fill:none;}.cls-3{fill:#00a5e3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1961"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_160"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1.85 15.35 1.85 29.54 .62 29.13 .62 15.35 1.85 15.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2.64,31.55c.08.04.17.08.25.09.09.02.14.02.32.02h13.33v1.23H3.61c-.29-.01-.53.03-.99-.05-.11-.44-.1-.9.02-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2.89,31.64c-.36-.07-.71-.42-.88-.87-.09-.22-.14-.47-.15-.72v-.93s-1.23,0-1.23,0c0,.43.08.86.35,1.32.14.21.29.4.46.55.41.52,1.04.79,1.46.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2.62,32.85c-.61-.13-1.04-.62-1.14-1.12-.06-.25-.07-.49-.05-.72.17.15.35.28.54.36.38.17.68.23.92.29l-.26,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m4.26,33.51v-.62s-.67,0-.67,0h-.34c-.11,0-.22,0-.4-.01l-.06.61.29.02h1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m4.27,31.67v-.62s-1.23,0-1.23,0l-.06.61s.16,0,.28,0h1.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.59,2.13c-.16-.42-.48-.76-.81-.86-.09-.03-.17-.04-.26-.04H4.55L4.96,0h11.2c.15,0,.26,0,.45,0,.21,0,.41.05.6.11.77.27,1.27.91,1.53,1.56l-1.15.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2.28,1.65c-.27.32-.43.79-.43,1.26v1.77s0,3.55,0,3.55v7.11H.62V3.29c0-.26,0-.61.06-.97.06-.34.17-.68.35-1,.45.04.88.15,1.26.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2.1,1.91c.23-.42.6-.68.97-.68h1.9V0c-.44,0-.87.1-1.28.31l-.62.31c-.65.22-.92.79-.96,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1.02,1.32c.25-.47.77-.85,1.32-.85.27,0,.52.05.73.15-.21.11-.36.25-.48.41-.22.32-.33.61-.49.89l-1.08-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m0,3.08h.62c-.01-.48.07-1.08.31-1.57l-.56-.26c-.14.3-.24.62-.3.94-.03.16-.05.32-.06.48,0,.17-.01.32-.01.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1.85,3.08h.62c0-.13,0-.21,0-.26,0-.06.01-.13.02-.19.02-.13.06-.24.11-.35l-.56-.26c-.15.32-.21.64-.2,1.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m16.53,31.67c1.77-.1,1.06-3.33,1.21-5.52v-7.1l1.23.41v10.34c.03.61-.11,1.38-.51,1.98-.38.61-1.1,1.14-1.94,1.13v-1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m17.74,16.1V3.66c0-.28,0-.63,0-.86-.01-.23-.06-.46-.14-.67l1.15-.45c.13.33.2.68.23,1.02.02.36,0,.6,0,.9v12.06l-1.23.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.74,15.67v3.79h1.23c0-.43-.1-.86-.31-1.28l-.31-.62-.61-1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m18.97,15.66c0,.43-.1.86-.31,1.28l-.31.62-.31-.62c-.21-.42-.31-.85-.31-1.28h1.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "19.59 14.15 18.97 14.15 18.97 15.5 19.59 15.5 19.59 14.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17.74 14.15 17.13 14.15 17.13 15.51 17.74 15.5 17.74 14.15"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Line_28"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "12.26 4.56 10.01 4.56 10.08 3.33 12.26 3.33 12.26 4.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "9.55 4.56 7.3 4.56 7.3 3.33 9.48 3.33 9.55 4.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m9.48,4.56h.6v-1.23c-.07,0-.14.1-.2.31l-.1.31-.3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m9.48,3.33c.07,0,.14.1.2.31l.1.31-.1.31c-.07.21-.13.31-.2.31v-1.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.24,
    y: 2.72,
    width: 0.21,
    height: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.24,
    y: 4.56,
    width: 0.21,
    height: 0.62
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePlaceholder);
export default __webpack_public_path__ + "static/media/mobile-placeholder.163294c362438bc86019a6b0ea0ee600.svg";
export { ForwardRef as ReactComponent };